import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import CartList from '../components/CartList';
import NavBarFooterDashboard from '../components/NavBarFooterDashboard';
import { fetchCheckoutData } from '../apis/checkoutApi';
import { useAuth } from '../context/AuthContext';
import StripeWrapper from '../components/StripeWrapper';

const Checkout = () => {
  const [message, setMessage] = useState('');
  const [cartData, setCartData] = useState(null);
  const { userProfileData, getUserData } = useAuth();  // This should now work
  const navigate = useNavigate();

  useEffect(() => { 
    const fetchData = async () => {  
      try {
        await getUserData();  
        const response = await fetchCheckoutData();
        setMessage(response.message);
        setCartData(response.data);
      } catch (error) {
        if (error.status === 401) {
          alert(error.message);
          navigate('/auth');
        } else {
          console.error('Error:', error.message);
        }
      }
    };
    fetchData();
  }, [navigate]);

  return (
    <>
      <StripeWrapper>
        <CartList cartData={cartData} userData={userProfileData} />
      </StripeWrapper>
      <NavBarFooterDashboard />
    </>
  );
};

export default Checkout;